import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ELITE_COMPARISON, ELITE_INCLUDES } from '../../data/content';
export function EliteValue() {
  return <section className="w-full border-y border-ink-border bg-ink-soft px-5 py-12 sm:py-16" data-id="element-68" data-mp="3ofn6aacyapy2">
      <div className="mx-auto max-w-5xl" data-id="element-69" data-mp="3tepyuvbqv3p5">
        <h2 className="text-center font-display text-3xl text-white sm:text-5xl" data-id="element-70" data-mp="22n8k5djnntw">
          🚀 ¿Qué agrega <span className="text-lime" data-id="element-71" data-mp="71rgytsn9hj6">Zumba Pro Elite?</span>
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-sm text-white/65 sm:text-base" data-id="element-72" data-mp="73kr4j2gujvx">
          La capa avanzada para que cada clase se sienta más profesional, variada y bien resuelta.
        </p>

        <div className="mt-8 overflow-x-auto rounded-xl border border-ink-border" data-id="element-73" data-mp="l0zfrlkwanmu">
          <table className="w-full min-w-[650px] border-collapse text-left text-sm" data-id="element-74" data-mp="kyn2hlq311g4">
            <thead className="bg-ink-card text-xs uppercase tracking-wider text-white/60" data-id="element-75" data-mp="2hv3zs2abyddy">
              <tr data-id="element-76" data-mp="2msmcm3rgxcr8">
                <th className="px-4 py-3 font-bold" data-id="element-77" data-mp="2mu77xvllwzq5">Situación en el aula</th>
                <th className="border-l border-ink-border px-4 py-3 font-bold" data-id="element-78" data-mp="3a8o0ktcn34jo">Solo Megapack</th>
                <th className="border-l border-lime/30 bg-lime/5 px-4 py-3 font-bold text-lime" data-id="element-79" data-mp="35etjzysbz5ot">+ Zumba Pro Elite</th>
              </tr>
            </thead>
            <tbody data-id="element-80" data-mp="2wg8285uonup3">
              {ELITE_COMPARISON.map(row => <tr key={row.situation} className="border-t border-ink-border" data-id="element-81" data-mp="2wdvch6ioog1h">
                  <th scope="row" className="bg-ink-card px-4 py-3 font-bold text-white" data-id="element-82" data-mp="3t55vtkqp5mko">{row.situation}</th>
                  <td className="border-l border-ink-border px-4 py-3 leading-snug text-white/65" data-id="element-83" data-mp="3o4rltx5jc2k0">{row.megapack}</td>
                  <td className="border-l border-lime/30 bg-lime/[0.03] px-4 py-3 leading-snug text-white/90" data-id="element-84" data-mp="3f667yfb0dbpk">{row.elite}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mx-auto mt-7 max-w-3xl rounded-xl border border-lime/35 bg-lime/5 p-5 sm:p-6" data-id="element-85" data-mp="23raj60indtva">
          <h3 className="font-display text-xl text-lime" data-id="element-86" data-mp="257oeb1y63h3i">✅ El Kit Elite incluye:</h3>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-87" data-mp="2a79fzk4q23jx">
            {ELITE_INCLUDES.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-white/85" data-id="element-88" data-mp="1w7rtxcit94e9">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-89" data-mp="208tld76hkc5o" />
                {item}
              </li>)}
          </ul>
        </div>

        <p className="mt-7 text-center font-display text-2xl text-magenta sm:text-3xl" data-id="element-90" data-mp="1mfvmvbyqy3xw">
          Sumá Zumba Pro Elite y llevá tus clases al siguiente nivel.
        </p>
      </div>
    </section>;
}